import React from 'react';
import { IOldIconProps } from './type';

const List: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.935 4.537c.666-.127 1.606.125 2.475.993a.748.748 0 00.56.22.748.748 0 00.56-.22c.869-.868 1.809-1.12 2.474-.993.614.116 1.143.577 1.25 1.546.212 1.906-.718 3.17-1.829 4.005-.56.42-1.155.718-1.64.91a5.778 5.778 0 01-.602.205c-.103.028-.163.04-.187.044a.065.065 0 00-.013.003h.014a.596.596 0 00-.054 0h.014s-.004-.002-.013-.003c-.024-.005-.084-.016-.187-.044a5.779 5.779 0 01-.603-.205 7.214 7.214 0 01-1.64-.91c-1.11-.834-2.04-2.1-1.829-4.005.108-.97.637-1.43 1.25-1.546zm-.28-1.474c1.084-.206 2.282.143 3.315.96 1.033-.817 2.23-1.166 3.314-.96 1.317.25 2.288 1.29 2.461 2.854.053.473.052.917.007 1.333H25c.966 0 1.75.784 1.75 1.75v17A1.75 1.75 0 0125 27.75H7A1.75 1.75 0 015.25 26V9c0-.966.784-1.75 1.75-1.75h3.188a6.11 6.11 0 01.006-1.333c.174-1.565 1.145-2.604 2.462-2.854zM10.572 8.75H7a.25.25 0 00-.25.25v17c0 .138.112.25.25.25h18a.25.25 0 00.25-.25V9a.25.25 0 00-.25-.25h-3.631c-.46 1.1-1.24 1.935-2.044 2.537a8.714 8.714 0 01-1.986 1.105c-.29.116-.551.2-.764.259a2.415 2.415 0 01-.635.099c-.172 0-.391-.05-.575-.1a7.254 7.254 0 01-.764-.258 8.715 8.715 0 01-1.986-1.104c-.804-.603-1.585-1.438-2.044-2.538zM13.25 17a.75.75 0 01.75-.75h7a.75.75 0 010 1.5h-7a.75.75 0 01-.75-.75zM10 16.25a.75.75 0 000 1.5h1a.75.75 0 000-1.5h-1zM13.25 21a.75.75 0 01.75-.75h7a.75.75 0 010 1.5h-7a.75.75 0 01-.75-.75zM10 20.25a.75.75 0 000 1.5h1a.75.75 0 000-1.5h-1z"
        fill={color}
      />
    </svg>
  );
};

export default List;
